export default {
  carWashDisputes: state => state.carWashDisputes,
  disputes: state => state.disputes,
  selectedDispute: state => state.selectedDispute,
  currentPageNumber: state => state.currentPageNumber,
  pageSize: state => state.pageSize,
  nextAvailablePage: state => state.nextAvailablePage
}
